
import Vue from 'vue'
import { mapGetters } from 'vuex'
import FacetInfoContainer, { FacetInfoContainerProps } from '~/components/facet-info/FacetInfoContainer.vue'
import { FacetFilter } from '~/store/types'
import { facetFiltersToQuery } from '~/store/algolia'

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'FacetInfoContainerCollection',
  components: { FacetInfoContainer },
  props: {
    collection: {
      type: Array,
      default: () => ([]),
    },
    algoliaRequestId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      currentFacetInfoContainer: undefined,
    }
  },
  computed: {
    ...mapGetters({
      facetFiltersVuex: 'algolia/facetFilters',
      countryCode: 'frontend/currentCountryCode',
    }),
    facetFilters () {
      return this.facetFiltersVuex(this.algoliaRequestId)
    }
  },
  watch: {
    facetFilters () {
      this.checkFacetMatch()
    }
  },
  created () {
    this.checkFacetMatch()
  },
  methods: {
    checkFacetMatch () {
      if (typeof this.collection === 'undefined') {
        return
      }

      const checkComponentValidity = (component: Story): component is Story => {
        return (
          typeof component !== 'undefined' &&
          typeof component.facetMatcher !== 'undefined' &&
          typeof component.facetMatcher.facetMatcher !== 'undefined' &&
          (component.countries?.includes('_all_countries') || component.countries?.includes(this.countryCode))
        )
      }

      for (const component of this.collection) {
        if (!checkComponentValidity(component)) {
          continue
        }
        const { facetMatcher: { facetMatcher } } = component
        if (!facetMatcher || facetMatcher === 'true') {
          // Set this component as the current one if it has no facetMatcher to get a default
          // This makes it so that if there are multiple facetInfoContainers with no facetMatcher
          // on the same page, the last one will be the one that is displayed
          this.currentFacetInfoContainer = component
          continue
        }

        // eslint-disable-next-line no-new-func
        const facetMatcherFunc = new Function(
          'facetFilters',
          // facetMatcher is a string that can be evaluated as a predicate
          `return ${facetMatcher.replace(/ /g, '').replace(/\n/g, '')}`,
        )

        const ƒacetQuery = facetFiltersToQuery(this.facetFilters)
        if (typeof ƒacetQuery !== 'undefined' && facetMatcherFunc(ƒacetQuery)) {
          this.currentFacetInfoContainer = component
          break
        }
      }
    },
  }
})

type Story = FacetInfoContainerProps & {
  component: string;
  _uid: string;
}

type StoryCollection = Story[]

interface Data {
  currentFacetInfoContainer?: Story;
}

interface Methods {
  checkFacetMatch: () => void;
}

interface Props {
  collection: StoryCollection;
  algoliaRequestId: string;
}

interface Computed {
  facetFiltersVuex: (algoliaRequestId: string) => FacetFilter[];
  countryCode: string;
  facetFilters: FacetFilter[];
}
